import { GRUSHKA_ORGANIZATION_ID } from '@app/access/constants/organizations';
import { config } from '@app/config';

export const getOnlyGrushkaAccess = (database: string | null) => {
  const { mode } = config;

  if (mode !== 'production') {
    return true;
  }

  return database === GRUSHKA_ORGANIZATION_ID;
};
